<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                :showModeOpenId="showModeOpenId"
                :viewParams="viewParams"
                :buttonsVisibility="buttonsVisibility"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <ProjectForm :formProps="formProps">
                </ProjectForm>
            </template>
            <template #search="searchProps">
                <ProjectSearch :searchProps="searchProps">
                </ProjectSearch>
            </template>

            <template #buttons>
                <BackButton v-if="isBackButtonVisible"
                            routeName="agreement-index"
                            :customData="{ 'id': viewParams.agreement_id }" />
            </template>

        </v-view>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { router } from '@inertiajs/vue3'
import ProjectForm from './ProjectForm.vue'
import ProjectSearch from './ProjectSearch.vue'
import BackButton from '@crud/BackButton.vue'
import { getFromUrl } from '@pages/Helper/utils.js';

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    viewParams: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])
const showModeOpenId = getFromUrl()
const isBackButtonVisible = ref(false)

//------------------------------------------------------------------------------

onMounted(() => {
    if (props.viewParams.agreement_id) {
        isBackButtonVisible.value = true
    }
})

//------------------------------------------------------------------------------

const rowButtonAction = async function (item, rowData) {
    router.visit(route('project-stages-view', { projectId: rowData.id, agreement_id: props.viewParams?.agreement_id ? true : false, backToView: true }), {
        onError: (errors) => {
            const message = errors?.error ?? 'Wystąpił nieznany błąd'
            screenMessage({ type: 'error', title: __('Error'), message: message });
        }
    })
}

// //------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
